import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const OnboardingRoutes: RouteBundle = {
  domain: 'onboarding',
  routes: [
    {
      urlPattern: 'getting-started',
      handler: EditorRoutes.gettingStartedFlow.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'gs/bioregistry',
      handler: EditorRoutes.registryActivationFlow.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: 'role-info', handler: EditorRoutes.roleInfoScreen.bind(EditorRoutes), legacy: true},
  ],
};
